import { supabase } from '../lib/supabase'
import type { AdmNfeHeader, AdmNfeItem, AdmNfseHeader, AdmNfseItem, AdmWithoutNfRow } from '../types/admDespesas'
import type { AdmCategoria, AdmCentroCusto } from '../types/admCadastros'
import type { AdmDashboardRawData } from '../types/admDashboard'

export const admDashboardService = {
  async loadAll(): Promise<AdmDashboardRawData> {
    const [
      nfeHeadersRes,
      nfseHeadersRes,
      nfeItemsRes,
      nfseItemsRes,
      withoutNfRes,
      categoriesRes,
      costCentersRes,
    ] = await Promise.all([
      supabase
        .from('adm_nfe_header')
        .select('*')
        .is('deleted_at', null)
        .order('issue_date', { ascending: false }),

      supabase
        .from('adm_nfse_header')
        .select('*')
        .is('deleted_at', null)
        .order('issue_date', { ascending: false }),

      supabase
        .from('adm_nfe_items')
        .select('id, nfe_id, description, ncm, quantity, unit, unit_value, total_value, category_id, cost_center_id'),

      supabase
        .from('adm_nfse_items')
        .select('id, nfse_id, description, service_code, quantity, unit_value, total_value, category_id, cost_center_id'),

      supabase
        .from('adm_without_nf')
        .select('*')
        .is('deleted_at', null)
        .order('expense_date', { ascending: false, nullsFirst: false })
        .order('created_at', { ascending: false }),

      supabase
        .from('adm_categories')
        .select('id, name')
        .is('deleted_at', null)
        .order('name'),

      supabase
        .from('adm_cost_centers')
        .select('id, name')
        .is('deleted_at', null)
        .order('name'),
    ])

    if (nfeHeadersRes.error) throw nfeHeadersRes.error
    if (nfseHeadersRes.error) throw nfseHeadersRes.error
    if (nfeItemsRes.error) throw nfeItemsRes.error
    if (nfseItemsRes.error) throw nfseItemsRes.error
    if (withoutNfRes.error) throw withoutNfRes.error
    if (categoriesRes.error) throw categoriesRes.error
    if (costCentersRes.error) throw costCentersRes.error

    const nfeHeaders = (nfeHeadersRes.data ?? []) as AdmNfeHeader[]
    const nfseHeaders = (nfseHeadersRes.data ?? []) as AdmNfseHeader[]
    const nfeHeaderIds = new Set(nfeHeaders.map((h) => h.id))
    const nfseHeaderIds = new Set(nfseHeaders.map((h) => h.id))
    const nfeItems = ((nfeItemsRes.data ?? []) as AdmNfeItem[]).filter((i) => nfeHeaderIds.has(i.nfe_id))
    const nfseItems = ((nfseItemsRes.data ?? []) as AdmNfseItem[]).filter((i) => nfseHeaderIds.has(i.nfse_id))
    const withoutNfRows = (withoutNfRes.data ?? []) as AdmWithoutNfRow[]

    const categoryMap = new Map<string, string>(
      ((categoriesRes.data ?? []) as AdmCategoria[]).map((c) => [c.id, c.name])
    )
    const costCenterMap = new Map<string, string>(
      ((costCentersRes.data ?? []) as AdmCentroCusto[]).map((c) => [c.id, c.name])
    )

    return {
      nfeHeaders,
      nfeItems,
      nfseHeaders,
      nfseItems,
      withoutNfRows,
      categoryMap,
      costCenterMap,
    }
  },
}
